
import {
    ISupportCategory,
    ISupportCategoryTopLevel,
} from 'Vue/interfaces/Interfaces';
import SupportCategoriesCard from 'Vue/components/supportCategories/SupportCategoriesCard.vue';
import { ISupportCategoriesAppTranslations } from 'Vue/interfaces/Interfaces';

export default {
    name: 'SupportCategories',
    components: {
        SupportCategoriesCard,
    },
    data() {
        return {
            supportCategories: [] as ISupportCategory[],
            currentCategory: [] as ISupportCategory[],
            categoryStack: [],
            supportCategoryError: false,
            translations: {} as ISupportCategoriesAppTranslations,
        };
    },
    methods: {
        async getSupportCategoriesData() {
            let categoryDiv = document.getElementById('productCategoriesData');
            let categoriesData: ISupportCategoryTopLevel = JSON.parse(
                categoryDiv.getAttribute('data-page-data')
            );
            this.supportCategories = categoriesData.SupportCategories;
            this.currentCategory = categoriesData.SupportCategories;
        },

        setCurrentCategory(childCategories) {
            this.currentCategory = childCategories;
        },

        enterCategory(currentCategory, childCategories) {
            this.categoryStack.push(currentCategory);
            this.setCurrentCategory(childCategories);
        },

        checkValue() {
            let input = this.$refs.searchInput;
            let inputValue = input.value;

            if (inputValue.length) {
                this.supportCategoryError = false;
            }
        },

        goBack() {
            this.setCurrentCategory(this.categoryStack.pop());
        },

        runLookup() {
            let input = this.$refs.searchInput;
            let inputValue = input.value;

            if (inputValue.length) {
                window.location.href = `/search?FilterCriteria.Query=${inputValue}&FilterCriteria.Tab=products`;
            } else {
                this.supportCategoryError = true;
            }
        },

        getTranslations() {
            let supportCategoryDiv = document.getElementById(
                'productCategoriesData'
            );
            return JSON.parse(
                supportCategoryDiv.getAttribute('data-translations')
            );
        },
    },
    created() {
        this.getSupportCategoriesData();
        this.translations = this.getTranslations();
    },
    mounted() {
        // console.log(this.supportCategories);
    },
};
